import Pencil from '~/components/icons/Pencil.tsx';
import { FormCheckbox } from '~/components/FormComponents/FormCheckbox.tsx';
import { Grid } from '@mui/material';

export interface PepInfoSectionProps {
  name: string;
  onChange: (isChecked: boolean) => void;
  text: string;
  onClick: () => void;
  isCheckboxDisabled: boolean;
  isButtonDisabled: boolean;
  isError?: boolean;
}

const PepInfoSection = ({
  name,
  text,
  onClick,
  onChange,
  isCheckboxDisabled,
  isButtonDisabled,
  isError,
}: PepInfoSectionProps) => {
  return (
    <Grid container size={{ sm: 12, md: 'auto' }} sx={{ alignItems: 'center' }} spacing={1}>
      <FormCheckbox name={name} label={text} onChange={onChange} disabled={isCheckboxDisabled} />
      <Grid sx={{ pb: 1 }}>
        <Pencil onClick={onClick} isDisabled={isButtonDisabled} isError={isError} />
      </Grid>
    </Grid>
  );
};

export default PepInfoSection;
